import React from 'react';

import Layout from '@hydra/common/app/Layout';
import ErrorBoundary from '@hydra/common/app/ErrorBoundary';
import { Shell } from '@hydra/types/shell';
import { useTheme } from '@material-ui/core/styles';

interface LayoutShellProps extends Shell {
  sideNav?: boolean
  sideNavType?: string
}

export default function LayoutShell (props: LayoutShellProps) {
  const theme = useTheme();
  const {
    className,
    children,
    sideNav,
    sideNavType,
    bgColor = theme.palette.background.default
  } = props;

  return (
    <ErrorBoundary sideNav={sideNav}>
      <Layout
        sideNav={sideNav || false}
        sideNavType={sideNavType}
        bgColor={bgColor}
        className={className}
      >
        {children}
      </Layout>
    </ErrorBoundary>
  );
}
